import { useSetRecoilState } from 'recoil';
import { blockLoadingState } from 'venn-state';
import React, { useEffect } from 'react';
import StudioShimmerBlock from './StudioShimmerBlock';
import { useBlockId } from '../contexts/BlockIdContext';

export const BlockSuspenseFallback = () => {
  const id = useBlockId();
  const setLoading = useSetRecoilState(blockLoadingState(id));

  useEffect(() => {
    setLoading(true);
    return () => setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <StudioShimmerBlock height={400} width="100%" />;
};
